import { detectMimeType } from './detectMIMEType';

export const returnImgSrc = (b64: string) => {
  return `data:${detectMimeType(b64)};base64,${b64}`;
};
